import React, { useEffect } from "react";
import "./styles/global.scss"; // Import your global styles here
import AppRouter from "./routes/AppRouter";
import { ModalProvider } from "./context/ModalContext";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocialLoginProvider } from "./context/SocialLoginConnect";
import {
  nativeAppleLoginSucceeded,
  nativeGoogleLoginSucceeded,
} from "./features/store/authSlice";
import { useAppDispatch } from "./hooks/hooks";
import { usePushNotifications } from "./hooks/usePushNotifications";
import { useAppsFlyerIdentity } from "./hooks/useAppsFlyerIdentity";
import { useModal } from "./context/ModalContext";
import { initAppsFlyerWeb } from "./lib/appsflyer";
import { clearReferralCode } from "./utils/referral";

function NativeSocialLoginBridge() {
  const dispatch = useAppDispatch();
  const { closeLoginModal, closeSignupModal } = useModal();

  useEffect(() => {
    const onGoogleSuccess = (event: Event) => {
      const { detail } = event as CustomEvent;
      if (!detail?.token || !detail?.user) return;
      dispatch(nativeGoogleLoginSucceeded(detail));
      clearReferralCode();
      closeLoginModal();
      closeSignupModal();
      toast.success("🎉 Logged in successfully!");
    };

    const onAppleSuccess = (event: Event) => {
      const { detail } = event as CustomEvent;
      if (!detail?.token || !detail?.user) return;
      dispatch(nativeAppleLoginSucceeded(detail));
      clearReferralCode();
      closeLoginModal();
      closeSignupModal();
      toast.success("🎉 Logged in successfully!");
    };

    window.addEventListener("native-google-login-success", onGoogleSuccess);
    window.addEventListener("native-apple-login-success", onAppleSuccess);
    return () => {
      window.removeEventListener("native-google-login-success", onGoogleSuccess);
      window.removeEventListener("native-apple-login-success", onAppleSuccess);
    };
  }, [closeLoginModal, closeSignupModal, dispatch]);

  return null;
}

function PushNotificationBridge() {
  usePushNotifications();
  return null;
}

function AppsFlyerBridge() {
  useEffect(() => {
    initAppsFlyerWeb();
  }, []);
  useAppsFlyerIdentity();
  return null;
}

function App() {
  return (
    <GoogleOAuthProvider clientId="245123695626-qj6qqme1sbfm0mtvq24fbj4e86943brb.apps.googleusercontent.com">
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div>Loading...</div>}>
          <ModalProvider>
            <ToastContainer />
            <NativeSocialLoginBridge />
            <PushNotificationBridge />
            <AppsFlyerBridge />
            <SocialLoginProvider>
              <div className="bg-white dark:bg-black">
                <AppRouter />
              </div>
            </SocialLoginProvider>
          </ModalProvider>
        </Suspense>
      </I18nextProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
